






































































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import Icon from '@/components/Icon.vue'
import Switcher from '@/components/Switcher.vue'
import EditFacilityBillingModal from './components/EditFacilityBillingModal.vue'
import EditCommissionsSettingsModal from './components/EditCommissionsSettingsModal.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { EZuntaInvoiceStatus, EZuntaInvoiceType, IFacility, IZuntaInvoice } from '@zunta/configurations'
import { ChainModule } from '@/store/modules/chain.module'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Table from '@/components/tables/Table.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { UserModule } from '@/store/modules/user.module'
import { getStatementPathByKey } from '@/utils/helpers'

@Component({
  name: 'FacilityBillingSettings',
  components: {
    Card,
    Table,
    Icon,
    Switcher,
    EditFacilityBillingModal,
    EditCommissionsSettingsModal
  }
})
export default class FacilityBillingSettings extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  EZuntaInvoiceStatus: any = EZuntaInvoiceStatus
  isWantEditBilling: boolean = false
  isWantEditCommissionsSettings: boolean = false
  user: User | null = Api.getUser()

  get facilityId () {
    return this.$route.params.id
  }

  get invoices () {
    return this.$store.state.chain.billingInvoices
  }

  get billingSettings () {
    return this.$store.state.facility.billingSettings || {}
  }

  get totalInvoices () {
    return this.$store.state.chain.totalInvoices
  }

  get invoicesFilters () {
    return { skip: 0, limit: 10 }
  }

  get commissionsSettings () {
    return this.$store.state.facility.commissionsSettings
  }

  config: ITableConfig = {
    useQuery: true,
    usePagination: true,
    rowClick: this.openInvoicePdf,
    rowClass: 'invoice-item-billing',
    fetchFunction: this.fetchInvoices,
    columns: [
      {
        minWidth: '150px',
        width: 15,
        key: 'invoiceMonth',
        hasSort: false,
        label: 'Invoice Month'
      },
      {
        minWidth: '150px',
        width: 15,
        key: 'invoiceDate',
        searchKey: 'invoiceDate',
        hasSort: true,
        label: 'Invoice Date',
        type: ETableColumnType.date
      },
      {
        minWidth: '150px',
        width: 25,
        key: 'invoiceType',
        searchKey: 'invoiceType',
        label: 'Invoice Type',
        hasSort: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 15,
        key: 'amount',
        searchKey: 'amount',
        hasSort: true,
        label: 'Amount',
        type: ETableColumnType.default
      },
      {
        class: 'text-left',
        minWidth: '250px',
        width: 30,
        key: 'status',
        searchKey: 'status',
        hasSort: true,
        label: 'Invoice Status',
        type: ETableColumnType.default
      }
    ]
  }

  async mounted () {
    this.userModuleInstance.getAdminUsersList({
      limit: 1000
    })
    await this.facilityModuleInstance.fetchCommissionsSettings(+this.facilityId)
    await this.facilityModuleInstance.fetchFacilityBillingSettings(+this.facilityId)
    await this.facilityModuleInstance.fetchFacilityPaymentAccount(+this.facilityId)
  }

  async fetchInvoices (filters: any) {
    await this.chainModuleInstance.getBillingInvoices({
      ...filters,
      status: EZuntaInvoiceStatus.PAID,
      facilityId: this.facilityId,
      dateRange: '02/01/2023'
    })
  }

  async toggleEnableBilling (value: boolean) {
    await this.facilityModuleInstance.saveFacilityBillingSettings({
      ...this.billingSettings,
      isActive: value,
      facility: +this.facilityId
    })
    this.billingSettings.isActive = value
  }

  openInvoicePdf (item: IZuntaInvoice) {
    if (item.pdf) {
      const facility: IFacility = item.facility as IFacility
      const name = `${(facility.shortName || facility.name).replace(/( |\s)/g, '_')}-${this.getInvoiceTypeLabel(item.type).replace(/( |\s)/g, '-')}-${new Date(item.invoiceDate).toLocaleDateString()}`.replace(/(\/|\\)/g, '.')
      window.open(getStatementPathByKey(item.pdf, name))
    }
  }

  getInvoiceTypeLabel (type: EZuntaInvoiceType) {
    switch (type) {
      case EZuntaInvoiceType.CC:
        return 'Credit Card'
      case EZuntaInvoiceType.ECHECK:
        return 'eCheck'
      case EZuntaInvoiceType.MAILING:
        return 'Mailing'
      case EZuntaInvoiceType.MONTHLY:
        return 'Monthly'
      default:
        return 'Unknown Type'
    }
  }

  async closeCommissionsModal () {
    this.isWantEditCommissionsSettings = false
    await this.facilityModuleInstance.fetchCommissionsSettings(+this.facilityId)
  }

  getInvoiceStatusLabel (status: EZuntaInvoiceStatus) {
    switch (status) {
      case EZuntaInvoiceStatus.NOT_PAID:
        return 'Unbilled'
      case EZuntaInvoiceStatus.NO_PAYMENT_METHOD:
        return 'No Payment Method'
      case EZuntaInvoiceStatus.PAID:
        return 'Paid'
      case EZuntaInvoiceStatus.REFUND:
        return 'Refund'
      case EZuntaInvoiceStatus.REJECTED:
        return 'Rejected'
      default:
        return 'Unknown Status'
    }
  }
}
